module.exports = __webpack_public_path__ + "static/media/test8_1.19b64a98.png";